<template>
  <el-dialog
    class="dialog-liantong-summary"
    title="开卡情况统计"
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="closed"
    width="1080px"
  >
    <LiantongChart />
    <template #footer>
      <el-button @click="closed">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import LiantongChart from '@/views/pages/recruitManage/liantong-chart/LiantongChart.vue'

export default {
  name: 'DialogLiantongSummary',
  components: { LiantongChart },
  mixins: [dialog]

}
</script>

<style lang="scss">
.dialog-liantong-summary {
  .el-dialog__body {
    height: 50vh;
    .liantong-chart{
      height: 100%;

    }
  }
}
</style>
